import React from "react";
import { Row, Col } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { image_base_url } from "../admin/api/api";
import "./GridTable.scss";

function GridTable({ title, items = [] }) {
 
  const navigate = useNavigate();
  //const IMAGE_BASE = "http://localhost:5170/";

  const handleNavigate = (productId) => {
    navigate("/productlist", { state: { productId } });
  };
  console.log(items);

  return (
    <div className="grid-table ">
      <h5 className="grid-title" style={{fontSize : "medium"}}>{title}</h5>

      <Row>
        {items.slice(0, 4).map((item, index) => (
          <Col xs={6} key={item.ProductId || index} className="mb-3">
            <div className="grid-card" onClick={() => handleNavigate(item.ProductId)}>
              
              <div className="image-wrapper">

                <img
                  src={item.image ? image_base_url + item.image : "/images/no-image.png"}
                  alt={item.productName}
                />

                {/* Discount badge */}
                {item.discountPercent > 0 && (
                  <div className="discount-badge">
                    {item.discountPercent}% OFF
                  </div>
                )}

                {index === 3 && (
                  <div className="overlay">
                    <span>Show More</span>
                  </div>
                )}

              </div>

              <p className="product-name">{item.productName}</p>

              {/* Price section */}
              <div className="price-section">

                <span className="price">₹{item.price}</span>

                {item.mrp && (
                  <span className="mrp">₹{item.mrp}</span>
                )}

              </div>


            </div>
          </Col>
        ))}
      </Row>
    </div>
  );
}

export default GridTable;